/**  
 * @param HTMLelement nav - the nav header 
 */
export default class Nav {
  static set nav(nav) {
    Nav.Nav = nav;
  }

  static set btn(btn) {
    Nav.Btn = btn;
  }

  static set btnLabel(btnLabel) {
    Nav.BtnLabel = btnLabel;
  }

  static set btnLabelEl(btnLabelEl) {
    Nav.BtnLabelEl = btnLabelEl;
  }

  static set clickout(clickout) {
    Nav.Clickout = clickout;
  }

  static set flyout(flyout) {
    Nav.Flyout = flyout;
  }  

  static set aside(aside) {
    Nav.Aside = aside;
  }

  static set btnsOpenSubs(btnsOpenSubs) {
    Nav.BtnsOpenSubs = btnsOpenSubs;
  }

  static set voices(voices) {
    Nav.Voices = voices;
  }

  static set subMenus(subMenus) {
    Nav.SubMenus = subMenus;
  }

  static set languageLabel(languageLabel) {
    Nav.LanguageLabel = languageLabel;
  }

  static set languageLabelEl(languageLabelEl) {
    Nav.LanguageLabelEl = languageLabelEl;
  }

  static openNav() {
    Nav.Nav?.classList.add("is-open");
    Nav.Btn?.classList.add("is-open");        

    if (Nav.BtnLabel && Nav.BtnLabelEl) {
      Nav.BtnLabelEl.textContent = Nav.BtnLabel;
    }
  }

  static closeNav(isMob) {
    if (isMob) {
      return;
    }

    Nav.Nav?.classList.remove("is-open");
    Nav.Btn?.classList.remove("is-open");
    Nav.Flyout?.querySelector(".is-open")?.classList.remove("is-open");
    Nav.Flyout?.querySelector(".is-active")?.classList.remove("is-active");

    if (Nav.BtnLabelEl) {
      Nav.BtnLabelEl.textContent = "Menu";
    }
  }

  static get isOpen() {
    return Nav.Nav.classList.contains("is-open");
  }

  static get navHeight() {
    return Nav.Nav?.offsetHeight;
  }

  static get flyoutWidth() {
    return Nav.Flyout?.offsetWidth;
  }

  static get asideHeight() {
    return Nav.Aside?.offsetHeight;
  }
}